import qs from 'querystringify'
import remote from './remote'

const URL = {
    GET_LOCATION: '/cms/location',
    GET_ALLOWED_LOCATION: '/cms/location/user',
    GET_ORGAN: '/cms/organ',
    GET_USERS: '/cms/organ/users',
    GET_CLIENT_ALL: '/cms/location/client',
    GET_ORGAN_SYNC: '/cms/organ/sync'
}

export default {
    getLocation () {
        return remote.request({
            url: remote.getUrl(URL.GET_LOCATION)
        })
    },
    getAllowedLocation () {
        return remote.request({
            url: remote.getUrl(URL.GET_ALLOWED_LOCATION)
        })
    },
    getOrgan () {
        return remote.request({
            url: remote.getUrl(URL.GET_ORGAN)
        })
    },
    getOrganSync () {
        return remote.request({
            url: remote.getUrl(URL.GET_ORGAN_SYNC)
        })
    },
    getUsers (organId) {
        return remote.request({
            url: remote.getUrl(URL.GET_USERS) + '/' + organId
        })
    },
    getClientAll(option) {
        let url = remote.getUrl(URL.GET_CLIENT_ALL)

        if (option) {
            url = url + '?' + qs.stringify(option)
        }

        return remote.request({
            url: url
        })
    }
}
